import CryptoJS from 'crypto-js';

export default new class encryptedMethods {
  encryptParameter(plainText) {
    var keeey = '3'+'e'+'3'+'5'+'e'+'e'+'a'+'4'+'7'+'1'+'7'+'7'+'5'+'1'+'9'+'1';
    var key = CryptoJS.enc.Utf8.parse(keeey);
    var iv = CryptoJS.enc.Utf8.parse(keeey);

    var encryptedValue = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(plainText),
      key,
      { keySize: 128 / 8, iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );

    return encryptedValue.toString();
  }

  decryptParam(cipherText) {
    var keeey = '3'+'e'+'3'+'5'+'e'+'e'+'a'+'4'+'7'+'1'+'7'+'7'+'5'+'1'+'9'+'1';
    var key = CryptoJS.enc.Utf8.parse(keeey);
    var iv = CryptoJS.enc.Utf8.parse(keeey);

    var decrypted = CryptoJS.AES.decrypt(cipherText, key, {
      keySize: 128 / 8,
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
